// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"c0d44ec7","734":"4632716f","853":"ae484d2f"}[chunkId] + ".chunk.js";
};